import { ChangeByRevisionList, EnhancedRevisionTypes } from './types';

export function mapRevisionsToChangeList(content: API.RevisionLog[]): ChangeByRevisionList {
  return content.flatMap(x => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { changes, ...rest } = x;
    return changes.length ? changes.map(change => ({ ...rest, ...change })) : [rest];
  });
}

export const mapChangeListEnhancedRevisionType = (list: ChangeByRevisionList) =>
  list.map(props => {
    const { from, to, revisionType } = props;
    let enhancedRevisionType: EnhancedRevisionTypes = revisionType;
    if (from && !to) enhancedRevisionType = 'deleted';
    if (!from && to) enhancedRevisionType = 'added';
    return { enhancedRevisionType, ...props };
  });
